/* Moteur de la colonne de filtres — Yumi & Cie, 01/08/2026.

   Ce fichier etait auparavant recopie dans le corps de deux sections, et les
   deux copies avaient deja diverge : celle de la page de resultats ignorait le
   perimetre de la page, le tri par defaut et la touche Entree sur le prix. Il
   est desormais charge par le snippet snippets/yc-filters.liquid, donc par
   TOUTE page qui affiche la colonne — page de rayon, page de marque, page de
   resultats — sans qu'on ait a y penser.

   Il ne fait rien s'il n'y a pas de formulaire de filtres sur la page. */

if (window.__ycFiltres) { /* deja installe */ } else {
window.__ycFiltres = 1;
(function () {
    var form = document.getElementById('yc-filter-form');
    if (!form) return;
    var preview = new URLSearchParams(location.search).get('preview_theme_id');

    /* Les liens « tout effacer / réinitialiser » gardent l'aperçu de thème */
    if (preview) {
      document.querySelectorAll('[data-keep-preview]').forEach(function (a) {
        var sep = a.href.indexOf('?') > -1 ? '&' : '?';
        a.href += sep + 'preview_theme_id=' + preview;
      });
    }

    /* Les filtres construisent une REQUETE, plus un chemin de tags.
       `/collections/all/a+b` est une intersection cote Shopify : deux
       categories differentes n'ont aucun produit commun, d'ou « Aucun
       produit ». La recherche, elle, comprend le OU et les parentheses, ce
       qui donne enfin le comportement attendu : OU dans un groupe, ET entre
       groupes. Verifie avant d'etre code : 142 + 100 = 242. */
    function citer(t) {
      return 'tag:"' + t.replace(/"/g, '') + '"';
    }

    /* ------------------------------------------------------------------
       CHAQUE CASE S'APPLIQUE DES LE CLIC (02/11/2026)

       Du 01/08 au 02/11, la selection se composait et ne partait qu'au clic
       sur « Voir les N produits ». Le client l'a jugee inutilisable : il
       cochait, rien ne bougeait. Desormais chaque case recharge la page avec
       la bonne selection, et l'on croise toujours deux criteres puisque la
       page rechargee garde les cases cochees.

       Ce qu'on ne perd pas en rechargeant : la position dans la page et dans
       la colonne, et, sur telephone, le panneau ouvert (voir garder()).
       ------------------------------------------------------------------ */
    /* Le prix, seul filtre natif restant, voyage avec l'adresse. */
    function natifs(qs) {
      form.querySelectorAll('input[type="number"][name]').forEach(function (i) {
        var v = parseFloat(i.value);
        if (i.value !== '' && !isNaN(v) && v > 0) qs.set(i.name, i.value);
      });
    }

    /* ------------------------------------------------------------------
       LES FILTRES SONT DES ETIQUETTES DANS L'ADRESSE (02/11/2026, nuit)

       /collections/<page>/<etiquette>+<etiquette> : le seul filtre EXACT de
       Shopify sans app, et le seul qui marche au-dela de 5 000 produits. La
       recherche, utilisee du 01/08 au 02/11, rendait des comptes faux et
       changeants (Sonoff : 77 a 87 au lieu de 178) et plafonnait a 1 000.
       Shopify veut les etiquettes triees : sinon il redirige.
       « En stock » est l'etiquette `en-stock`, posee par le robot (stock > 0).

       Plusieurs choix dans un meme groupe (deux marques, deux categories) :
       l'adresse ne sait faire que le ET. Les choix d'un groupe s'excluent —
       un produit n'a qu'une marque, qu'une categorie, qu'un rayon — donc le
       resultat est la SOMME des branches : elles partent dans yc_ou, et
       chargerBranches() les charge et les additionne.

       Texte tape (« clim ») : la recherche du texte, puis le moteur trie ses
       resultats selon les etiquettes (yc_f, trierTexte()).
       ------------------------------------------------------------------ */
    function poigneeDe(q) {
      var box = null;
      form.querySelectorAll('input[data-q]').forEach(function (i) {
        if (!box && i.getAttribute('data-q') === q) box = i;
      });
      return box ? box.getAttribute('data-tag') : '';
    }

    function construire() {
      var groupes = {};
      form.querySelectorAll('input[data-q]:checked').forEach(function (i) {
        var q = i.getAttribute('data-q');
        var g = q.split(':')[0];
        if (!groupes[g]) groupes[g] = [];
        if (groupes[g].indexOf(q) === -1) groupes[g].push(q);
      });

      /* Un rayon coche rend inutiles ses propres categories : le tag de rayon
         les couvre toutes. */
      if (groupes['univers'] && groupes['cat']) {
        var rayons = groupes['univers'].map(function (x) { return x.slice(8); });
        groupes['cat'] = groupes['cat'].filter(function (c) {
          var box = form.querySelector('input[data-q="' + c + '"]');
          var dans = box && box.getAttribute('data-dans');
          return !dans || rayons.indexOf(dans) === -1;
        });
        if (!groupes['cat'].length) delete groupes['cat'];
      }

      /* Les cases sans prefixe (« En stock », « moins cher qu'Amazon ») sont
         des etiquettes nues, chacune son groupe d'un seul choix. */
      var nus = [];
      form.querySelectorAll('input[data-tag]:not([data-q]):checked').forEach(function (i) {
        var t = i.getAttribute('data-tag');
        if (nus.indexOf(t) === -1) nus.push(t);
      });

      var sortSel = document.querySelector('select[form="yc-filter-form"]');
      var tri = sortSel ? sortSel.value : '';
      var qs = new URLSearchParams();
      var texte = form.getAttribute('data-texte') || '';

      if (texte) {
        /* Recherche tapee : le texte seul part chez Shopify, la selection
           (etiquettes brutes) dans yc_f. */
        var brut = Object.keys(groupes).map(function (g) { return groupes[g].join('|'); }).concat(nus);
        qs.set('type', 'product');
        qs.set('q', texte);
        qs.set('options[prefix]', 'none');
        natifs(qs);
        if (brut.length) qs.set('yc_f', brut.join('~'));
        /* « Pertinence » n'a pas le meme nom ici : relevance est le defaut. */
        if (tri && tri !== 'relevance' && tri !== 'best-selling' && tri !== 'manual') qs.set('sort_by', tri);
        if (preview) qs.set('preview_theme_id', preview);
        return { url: '/search?' + qs.toString() };
      }

      var et = nus.slice(), ou = [];
      Object.keys(groupes).forEach(function (g) {
        var h = groupes[g].map(poigneeDe).filter(Boolean);
        if (h.length === 1) et.push(h[0]);
        else if (h.length > 1) ou.push(h.join('|'));
      });
      et.sort();
      var base = form.getAttribute('data-base') || location.pathname;
      natifs(qs);
      if (ou.length) qs.set('yc_ou', ou.join('~'));
      /* « Pertinence » (relevance, best-selling, manual) est l'ordre propre a
         chaque page : on ne l'emporte pas sur une autre page. */
      var ici = location.pathname.indexOf(base) === 0;
      var pertinence = ['relevance', 'best-selling', 'manual'].indexOf(tri) > -1;
      if (tri && tri !== form.getAttribute('data-default-sort') && !(pertinence && !ici) && tri !== 'relevance') {
        qs.set('sort_by', tri);
      }
      if (preview) qs.set('preview_theme_id', preview);
      var q0 = qs.toString();
      return { url: base + (et.length ? '/' + et.join('+') : '') + (q0 ? '?' + q0 : '') };
    }

    function naviguer() {
      location.href = construire().url;
    }

    /* Recharger sans perdre sa place : on note la position de la page, celle
       de chaque tiroir qui defile, et le panneau du telephone ouvert. La page
       suivante les reprend une seule fois, dans les 20 secondes. */
    var CLE = 'yc-filtres-place';
    var bascule = document.getElementById('yc-filters-toggle');
    var defilants = function () {
      return [form].concat(Array.prototype.slice.call(form.querySelectorAll('.yc-filters__body')));
    };
    function garder() {
      try {
        sessionStorage.setItem(CLE, JSON.stringify({
          t: Date.now(),
          y: window.scrollY,
          p: !!(bascule && bascule.checked),
          s: defilants().map(function (el) { return el.scrollTop; })
        }));
      } catch (e) {}
      /* Le temps du chargement, les produits affiches ne sont plus les bons. */
      var grille = document.querySelector('.yc-grid3');
      if (grille) grille.style.opacity = '0.45';
      naviguer();
    }
    try {
      var place = JSON.parse(sessionStorage.getItem(CLE) || 'null');
      sessionStorage.removeItem(CLE);
      if (place && Date.now() - place.t < 20000) {
        if (place.p && bascule) bascule.checked = true;
        defilants().forEach(function (el, i) { if (place.s[i]) el.scrollTop = place.s[i]; });
        window.scrollTo(0, place.y || 0);
      }
    } catch (e) {}

    /* Etat d'une case de rayon en fonction de ses categories. */
    function majRayon(ray) {
      var box = form.querySelector('input[data-rayon="' + ray + '"]');
      if (!box) return;
      var cats = form.querySelectorAll('input[data-dans="' + ray + '"]');
      if (!cats.length) return;
      var n = 0;
      cats.forEach(function (i) { if (i.checked) n++; });
      box.checked = n === cats.length;
      box.indeterminate = n > 0 && n < cats.length;
    }
    /* ------------------------------------------------------------------
       RECHERCHE TAPEE + ETIQUETTES (02/11/2026) — voir construire().
       Le serveur ne connait pas yc_f : on recoche les cases, puis on trie
       tous les resultats du texte (jusqu'a 1 000, le plafond de Shopify).
       ------------------------------------------------------------------ */
    var YC_F = new URLSearchParams(location.search).get('yc_f') || '';
    var SEL = YC_F ? YC_F.split('~').map(function (g) { return g.split('|'); }) : [];
    if (SEL.length) {
      form.querySelectorAll('input[data-tag]').forEach(function (i) {
        var v = i.getAttribute('data-q') || i.getAttribute('data-tag');
        SEL.forEach(function (g) { if (g.indexOf(v) > -1) i.checked = true; });
      });
    }

    function trierTexte() {
      var grille = document.querySelector('.yc-grid3');
      if (!grille) return;
      grille.style.opacity = '0.45';
      var p = new URLSearchParams(location.search);
      p.delete('yc_f');
      p.set('view', 'yc-tout');
      var garde = [];
      var bas = function (s) { return String(s).toLowerCase(); };
      var choix = SEL.map(function (g) { return g.map(bas); });
      function page(k) {
        p.set('page', k);
        return window.fetch('/search?' + p.toString())
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            var doc = new DOMParser().parseFromString(h, 'text/html');
            doc.querySelectorAll('.yc-tout').forEach(function (el) {
              var tags = (el.getAttribute('data-tags') || '').split('|').map(bas);
              var ok = choix.every(function (g) {
                return g.some(function (t) { return tags.indexOf(t) > -1; });
              });
              if (ok) garde.push(el.innerHTML);
            });
            var pages = parseInt((doc.querySelector('[data-pages]') || { getAttribute: function () { return '1'; } }).getAttribute('data-pages'), 10) || 1;
            return k < pages && k < 4 ? page(k + 1) : null;
          });
      }
      page(1).then(function () {
        grille.innerHTML = garde.length ? garde.join('')
          : '<div class="yc-catempty" style="grid-column: 1 / -1;"><p>Aucun produit ne correspond à cette sélection.</p></div>';
        var n = garde.length;
        var c = document.querySelector('.yc-cathead__count');
        if (c) c.textContent = '· ' + n + ' produit' + (n > 1 ? 's' : '');
        var pag = document.querySelector('.yc-pagination');
        if (pag) pag.hidden = true;
        grille.style.opacity = '';
      }).catch(function () { grille.style.opacity = ''; });
    }
    if (SEL.length && form.getAttribute('data-texte')) trierTexte();

    /* ------------------------------------------------------------------
       PLUSIEURS CHOIX DANS UN GROUPE (yc_ou) — voir construire().
       La page affichee porte les etiquettes communes ; on charge chaque
       branche (page + communes + un choix par groupe), on additionne, et
       l'on affiche 48 cartes a la fois. Compte exact : les choix d'un
       groupe s'excluent, et l'on dedoublonne quand meme.
       ------------------------------------------------------------------ */
    var YC_OU = new URLSearchParams(location.search).get('yc_ou') || '';
    var OU = YC_OU ? YC_OU.split('~').map(function (g) { return g.split('|'); }) : [];
    if (OU.length) {
      form.querySelectorAll('input[data-tag]').forEach(function (i) {
        var h = i.getAttribute('data-tag');
        OU.forEach(function (g) { if (g.indexOf(h) > -1) i.checked = true; });
      });
    }

    function chargerBranches() {
      var grille = document.querySelector('.yc-grid3');
      var m = location.pathname.match(/^(\/collections\/[^\/]+)(?:\/([^\/?]+))?/);
      if (!grille || !m) return;
      var compteur = document.querySelector('.yc-cathead__count');
      /* Le compte de la page de base n'est pas celui de la selection. */
      if (compteur) compteur.textContent = '· …';
      grille.style.opacity = '0.45';
      var pag = document.querySelector('.yc-pagination');
      if (pag) pag.hidden = true;

      var communes = m[2] ? decodeURIComponent(m[2]).split('+') : [];
      var branches = [[]];
      OU.forEach(function (g) {
        var suivantes = [];
        branches.forEach(function (b) { g.forEach(function (h) { suivantes.push(b.concat([h])); }); });
        branches = suivantes;
      });
      var chemins = branches.map(function (b) { return m[1] + '/' + communes.concat(b).sort().join('+'); });
      var p = new URLSearchParams(location.search);
      p.delete('yc_ou');
      p.delete('page');
      var tri = p.get('sort_by') || '';

      /* 1. Le compte : une petite requete par branche, toutes ensemble. */
      var pc = new URLSearchParams();
      ['filter.v.price.gte', 'filter.v.price.lte', 'preview_theme_id'].forEach(function (k) {
        if (p.get(k)) pc.set(k, p.get(k));
      });
      pc.set('view', 'count');
      Promise.all(chemins.map(function (ch) {
        return window.fetch(ch + '?' + pc.toString())
          .then(function (r) { return r.ok ? r.text() : '0'; })
          .then(function (t) { return parseInt(String(t).replace(/[^0-9]/g, ''), 10) || 0; });
      })).then(function (ns) {
        var n = ns.reduce(function (s, x) { return s + x; }, 0);
        if (compteur) compteur.textContent = '· ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' produit' + (n > 1 ? 's' : '');
      });

      /* 2. Les cartes, 48 par 48 : chaque branche est un flux trie par
         Shopify ; on prend la meilleure tete (tri) ou on alterne (Pertinence). */
      p.set('view', 'yc-tout');
      var vus = {};
      var flux = chemins.map(function (ch) { return { ch: ch, page: 0, fini: false, file: [] }; });
      function remplir(f) {
        f.page += 1;
        p.set('page', f.page);
        return window.fetch(f.ch + '?' + p.toString())
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) {
            var doc = new DOMParser().parseFromString(h, 'text/html');
            doc.querySelectorAll('.yc-tout').forEach(function (el) {
              var id = el.getAttribute('data-h');
              if (vus[id]) return;
              vus[id] = 1;
              f.file.push({ html: el.innerHTML, prix: +el.getAttribute('data-prix') || 0,
                            titre: el.getAttribute('data-titre') || '', date: +el.getAttribute('data-date') || 0 });
            });
            var d = doc.querySelector('[data-pages]');
            var pages = d ? parseInt(d.getAttribute('data-pages'), 10) || 1 : 1;
            if (f.page >= pages) f.fini = true;
          })
          .catch(function () { f.fini = true; });
      }
      var cmp = {
        'price-ascending': function (a, b) { return a.prix - b.prix; },
        'price-descending': function (a, b) { return b.prix - a.prix; },
        'title-ascending': function (a, b) { return a.titre.localeCompare(b.titre, 'fr'); },
        'title-descending': function (a, b) { return b.titre.localeCompare(a.titre, 'fr'); },
        'created-descending': function (a, b) { return b.date - a.date; },
        'created-ascending': function (a, b) { return a.date - b.date; }
      }[tri];
      var tour = 0;
      function prendre(n, out) {
        out = out || [];
        if (out.length >= n) return Promise.resolve(out);
        var vides = flux.filter(function (f) { return !f.file.length && !f.fini; });
        if (vides.length) return Promise.all(vides.map(remplir)).then(function () { return prendre(n, out); });
        var pleins = flux.filter(function (f) { return f.file.length; });
        if (!pleins.length) return Promise.resolve(out);
        var choix;
        if (cmp) {
          choix = pleins.reduce(function (x, y) { return cmp(x.file[0], y.file[0]) <= 0 ? x : y; });
        } else {
          choix = pleins[tour % pleins.length];
          tour += 1;
        }
        out.push(choix.file.shift().html);
        return prendre(n, out);
      }
      function reste() {
        return flux.some(function (f) { return f.file.length || !f.fini; });
      }

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'yc-filters__resetbtn';
      plus.style.cssText = 'display:block;margin:24px auto;';
      plus.textContent = 'Voir plus de produits';
      plus.hidden = true;
      grille.parentNode.insertBefore(plus, grille.nextSibling);
      var premier = true;
      function suite() {
        plus.disabled = true;
        return prendre(48).then(function (cartes) {
          if (premier) {
            grille.innerHTML = cartes.length ? '' : '<div class="yc-catempty" style="grid-column: 1 / -1;"><p>Aucun produit ne correspond à cette sélection.</p></div>';
            premier = false;
          }
          grille.insertAdjacentHTML('beforeend', cartes.join(''));
          grille.style.opacity = '';
          plus.disabled = false;
          plus.hidden = !reste();
        });
      }
      plus.addEventListener('click', suite);
      suite().catch(function () { grille.style.opacity = ''; });
    }
    if (OU.length && !form.getAttribute('data-texte')) chargerBranches();

    /* Un rayon coche par le serveur implique toutes ses categories. Sans ce
       premier passage, majRayon() les compte a zero et vide la case : le rayon
       devenait indecochable et un second rayon remplacait le premier. */
    form.querySelectorAll('input[data-rayon]:checked').forEach(function (b) {
      var ray = b.getAttribute('data-rayon');
      form.querySelectorAll('input[data-dans="' + ray + '"]').forEach(function (i) {
        i.checked = true;
      });
    });
    form.querySelectorAll('input[data-rayon]').forEach(function (b) {
      majRayon(b.getAttribute('data-rayon'));
    });

    /* Anciennes adresses (avant le 02/11/2026 au soir) : /search?q=tag:...
       sans texte tape. La recherche y comptait faux ; on repart aussitot vers
       l'adresse de collection equivalente — les cases sont deja cochees par le
       serveur, et l'ancien filtre de disponibilite devient « En stock ». */
    var ancienne = new URLSearchParams(location.search);
    if (location.pathname === '/search' && !form.getAttribute('data-texte')
        && /tag:/.test(ancienne.get('q') || '')) {
      if (ancienne.getAll('filter.v.availability').indexOf('1') > -1) {
        form.querySelectorAll('input[data-tag="en-stock"]').forEach(function (i) { i.checked = true; });
      }
      location.replace(construire().url);
    }

    /* Le bouton « Voir les N produits » ne sert plus que sur telephone : la
       selection est deja appliquee, il referme le panneau sur les produits.
       Sans JavaScript le formulaire part vers la page d'origine. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (bascule && bascule.checked) {
        bascule.checked = false;
        window.scrollTo(0, 0);
        return;
      }
      naviguer();
    });
    /* Le bouton « Appliquer » a disparu : le champ prix doit donc partir tout
       seul. « change » sur un champ nombre ne se déclenche qu'à la validation
       (perte de focus ou Entrée), jamais à chaque frappe. */
    form.addEventListener('change', function (e) {
      /* Le champ de recherche d'un tiroir emet « change » en perdant le focus.
         Il ne participe a aucun filtre : sans cette porte, cliquer ailleurs
         rechargerait la page pour rien. */
      if (e.target && e.target.classList && e.target.classList.contains('yc-filters__search')) {
        return;
      }
      /* Miroir : si le meme tag est rendu par plusieurs cases, elles doivent
         basculer ensemble. Sinon decocher l'une laisse les autres cochees,
         le filtre survit a sa propre suppression et le clic reste sans
         effet — c'est exactement ce qu'a vu le client. */
      var t = e.target && e.target.getAttribute && e.target.getAttribute('data-tag');
      if (t) {
        form.querySelectorAll('input[data-tag="' + t + '"]').forEach(function (i) {
          i.checked = e.target.checked;
        });
      }

      /* Cocher un rayon coche toutes ses categories, le decocher les decoche
         toutes. C'est ce qu'un visiteur attend d'une case « Tout le rayon », et
         c'est ce qui manquait. */
      var ray = e.target && e.target.getAttribute && e.target.getAttribute('data-rayon');
      if (ray) {
        form.querySelectorAll('input[data-dans="' + ray + '"]').forEach(function (i) {
          i.checked = e.target.checked;
        });
      }
      /* Et l'inverse : cocher toutes les categories d'un rayon remplit sa case,
         en cocher une partie la met en etat indetermine. Une case vide alors que
         la moitie du rayon est selectionnee, c'est un mensonge visuel. */
      var dans = e.target && e.target.getAttribute && e.target.getAttribute('data-dans');
      if (dans) majRayon(dans);
      garder();
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.type === 'number') {
        /* Entree dans un champ de prix vaut validation explicite. */
        e.preventDefault();
        naviguer();
      }
    });
    var sortSel = document.querySelector('select[form="yc-filter-form"]');
    if (sortSel) {
      /* Le tri n'est pas un choix multiple : changer de tri est une demande
         de resultat, pas une etape de composition. Il part donc tout de suite,
         en emportant ce qui est coche a cet instant. */
      sortSel.addEventListener('change', naviguer);
    }

    /* Recherche dans un tiroir : elle CACHE des etiquettes, elle ne filtre
       pas la boutique. Aucune navigation, aucun appel reseau — sinon taper
       « son » rechargerait la page a chaque lettre. */
    form.querySelectorAll('.yc-filters__search').forEach(function (ch) {
      var corps = ch.closest('.yc-filters__body');
      /* On compare sans accents ni casse : « creality » doit trouver
         « CREALITY », et « telesin » doit trouver « Telesin ». normalize('NFD')
         decompose les lettres accentuees, la classe ̀-ͯ retire les
         signes diacritiques. */
      var pli = function (s) {
        return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase() : s.toLowerCase();
      };
      ch.addEventListener('input', function () {
        var q = pli(ch.value.trim());
        corps.querySelectorAll('label').forEach(function (l) {
          /* On lit le libelle de la marque, pas tout le contenu de l'etiquette :
             le compteur qui la suit ferait correspondre n'importe quel chiffre. */
          var sp = l.querySelector('span');
          var t = pli((sp ? sp.textContent : l.textContent).trim());
          l.hidden = q !== '' && t.indexOf(q) === -1;
        });
      });
      /* Entree ne doit pas soumettre le formulaire depuis ce champ. */
      ch.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); }
      });
    });
  })();
}
